module.exports = __webpack_public_path__ + "images/services/dropbox-preview-logo.6ce076639861d2c74aaf.svg";